module.exports = __webpack_public_path__ + "img/dyyjy.ef9aebd7.png";